var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TicketSearchForm", {
        ref: "ticketSearchForm",
        on: {
          search: _vm.doSearch,
          reset: _vm.resetSearch,
          export: _vm.doExport
        },
        model: {
          value: _vm.searchData,
          callback: function($$v) {
            _vm.searchData = $$v
          },
          expression: "searchData"
        }
      }),
      _vm._v(" "),
      _c("ViewTicketTable", {
        attrs: {
          list: _vm.ticketList,
          viewId: _vm.currentViewId,
          tableEmptyPlaceholder: _vm.tableEmptyPlaceholder
        },
        on: {
          "sort-change": _vm.tableSortChange_2,
          "selection-change": _vm.selectionChange,
          "after-close-ticket": _vm.queryTicketList
        }
      }),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          "pager-count": 9,
          "current-page": _vm.page.pageNumber,
          "page-sizes": [10, 20, 50, 100, 200, 500, 1000],
          "page-size": _vm.page.pageSize,
          total: _vm.recordCount || 0
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.queryTicketList
        }
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "50px" } }),
      _vm._v(" "),
      _c("TicketBatchOperationBar", {
        ref: "TicketBatchOperationBar",
        on: { cancel: _vm.queryTicketList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47e162f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e162f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/ViewTicketList.vue
// module id = 704
// module chunks = 75